module.exports = __webpack_public_path__ + "img/CM-PW-25-Kia-Playful.ef224382.jpg";